import React from "react";
import Map, {
    Markers,
    Polylines,
    Polygons,
    Overlays,
    Marker,
    Controls,
} from "./googlemaps/";
import _ from "lodash";
import { getCurrentPage } from "../helpers";
import POIItem from "./POIItem";
import RouteProfile from "./RouteProfile";
import DropDownLinks from "./DropDownLinks";

class MapWrapper extends React.Component {

    handleButtonClick = () => {
        this.props.handleSubmit();
    }

    render() {
        const markers = _.omit(
            this.props.map.markers || {},
            ["geolocation"]
        );
        
        const valid_locations = _.filter(
            this.props.locations || [],
            (location) =>
                location &&
                location.lat !== undefined &&
                location.lat !== null &&
                location.lng !== undefined &&
                location.lng !== null
        );

        const fitToLocationMarkersOnly =
            valid_locations.length >= 1 ||
            getCurrentPage() === "leisure-rides" ||
            getCurrentPage() === "single-cycle-route";

        const fitBounds = fitToLocationMarkersOnly
            ? {
                markers: ["routePlanner"],
                polylines: true
            }
            : {
                markers: true,
                polylines: false
            };

        const geolocation =
            this.props.map &&
            this.props.map.markers &&
            this.props.map.markers.geolocation;

        return (
            <div className="map-wrapper">

                <DropDownLinks />

                <Map
                    fitBounds={fitBounds}
                    {...this.props}
                >

                    <Markers
                        markers={markers}
                        {...this.props}
                    />

                    {geolocation &&
                        geolocation[0] &&
                        geolocation[0].location && (
                            <Marker
                                markerlocation={
                                    geolocation[0].location
                                }
                                icon={
                                    geolocation[0].icon
                                }
                                title={
                                    geolocation[0].title
                                }
                                visible={
                                    geolocation[0].visible
                                }
                                {...this.props}
                            />
                        )}

                    {geolocation &&
                        geolocation[1] &&
                        geolocation[1].location && (
                            <Marker
                                markerlocation={
                                    geolocation[1].location
                                }
                                icon={
                                    geolocation[1].icon
                                }
                                title={
                                    geolocation[1].title
                                }
                                visible={
                                    geolocation[1].visible
                                }
                                {...this.props}
                            />
                        )}

                    <Polylines
                        polylines={
                            this.props.map.polylines || []
                        }
                        {...this.props}
                    />

                    <Polygons
                        polygons={
                            this.props.map.polygons || []
                        }
                        {...this.props}
                    />

                    <Overlays
                        overlays={
                            this.props.map.overlays || []
                        }
                        {...this.props}
                    />

                    <Controls {...this.props} />

                    {this.props.showbikeParking !== false && (
                        <div className="bike-parking-wrapper">
                            <POIItem
                                poiType={"bikeParking"}
                                label={"Show Bike Parking"}
                                valid_locations={
                                    valid_locations
                                }
                                {...this.props}
                            />
                        </div>
                    )}

                </Map>

                <div className="large-content">
                    {getCurrentPage() === "route-planning" && (
                        <RouteProfile {...this.props} />
                    )}
                </div>

            </div>
        );
    }
}

export default MapWrapper;


// WEBPACK FOOTER //
// ./src/components/MapWrapper.js